// Globals
import React, { useCallback, useEffect, useState } from 'react';
import { Upload } from 'antd';
import { useTranslation } from 'react-i18next';

// Components
import { UploadIcon } from '@/icons';
import { Button } from '@/ui';
import { FileOutlined } from '@ant-design/icons';

type TUploadDragger = {
  value?: string | File | Blob;
  onChange?: (file: File | Blob, imageUrl: string) => void;
  acceptance?: string;
};

const UploadDragger = ({ acceptance, value, onChange }: TUploadDragger) => {
  const { t } = useTranslation();
  const [document, setDocument] = useState<string | File | Blob | undefined>(value);

  const handleChange = useCallback(
    async (image: Blob) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onloadend = async () => {
        if (typeof reader.result === 'string') {
          const url = reader.result;
          setDocument(url);
          onChange?.(image, url);
        }
      };
      return false;
    },
    [onChange],
  );

  useEffect(() => {
    setDocument(value);
  }, [value]);

  return (
    <Upload.Dragger maxCount={1} accept={acceptance} showUploadList={false} beforeUpload={handleChange}>
      {document ? (
        <FileOutlined style={{ height: '2rem', width: '2rem' }} />
      ) : (
        <UploadIcon style={{ height: '1rem', width: '100%' }} />
      )}

      <p>{t('image_upload_drag_text')}</p>
      <Button type={'primary'}>{t('image_upload_choose_text')}</Button>
    </Upload.Dragger>
  );
};

export default UploadDragger;
